import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import './style.module.css';
import { useRef } from 'react';
import { BASEAPIURL, showdatetimein, UPLOADNODEURLCDN } from '../../config';

const Invoice = () => {
    const printRef = useRef();
    const { InvoiceID } = useParams();

    const handleDownloadPdf = async () => {
        setDownloading(true);
        const element = printRef.current;
        // const canvas = await html2canvas(element, { scale: 2 }); // higher scale = better quality
        const canvas = await html2canvas(element, { 
            scale: 2,
            useCORS: true, // allow cross-origin images
            // allowTaint: false
        });
        const data = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        // const borderImage = "/logo.png"; // public folder or base64
        // // Page dimensions
        // const pageWidth = pdf.internal.pageSize.getWidth();
        // const pageHeight = pdf.internal.pageSize.getHeight();
        // // Add border image as background/frame
        // pdf.addImage(borderImage, "PNG", 0, 0, pageWidth, pageHeight);

        pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);

        // Add footer text at fixed position (bottom of page)
        pdf.setFontSize(8);
        pdf.text("Email: info@acumenglow.com    Mobile: +971 4 718 7101", 105, 290, { align: "center" });

        pdf.save(`Acumen-Glow-Invoice-${InvoiceID}.pdf`);
        setDownloading(false);
    };

    const [downloading, setDownloading] = useState(false);
    const [invoiceIni, setInvoiceIni] = useState('INVOICE');
    const [invoiceData, setInvoicesData] = useState({});
    const [studentData, setStudentData] = useState({});
    const [products, setProducts] = useState([]);
    const [coursesData, setCoursesData] = useState({});
    const FetchInvoice = async (objects = {}) => {
        try {
            const res = await fetch(`${BASEAPIURL}/student/invoiceData`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
                body: JSON.stringify(objects),
            });
            const resJson = await res.json();
            if (res.status === 200 && resJson && resJson.data && resJson.data._id) {                
                setInvoicesData(resJson.data);
                setInvoiceIni(resJson.invoiceIni);
                setStudentData(resJson.student);
                setProducts(resJson.products);
                setCoursesData(resJson.coursesData);
            } else {
                setInvoicesData({});
            }
        } catch (err) {
            console.log(err);
            setInvoicesData({});
        }
    };

    useEffect(() => {
        FetchInvoice({ InvoiceID });
    }, [InvoiceID]);

    if (!invoiceData._id) {
        return (
            <>
                <div className="pt-3 pb-3 mt-5 text-center">
                    <h3 ref={printRef} className=" mt-5 container text-center text-danger">
                        Something went wrong, Please again later.
                    </h3>
                    <a href="/" className='btn btn-lg mt-3 btn-success'>Back to Home</a>
                </div>
            </>
        )
    }

    return (
        <>
        <div className="pt-3 pb-3 container" style={{ minWidth: '1024px' }}>
            <div className='text-center'>
                {downloading ? (
                    <button className="mb-4 btn btn-danger px-4 py-2 rounded-lg">
                        Downloading...
                    </button>
                ) : (
                    <button
                        onClick={handleDownloadPdf}
                        className="mb-4 btn btn-info px-4 py-2 rounded-lg"
                    >
                        Download Invoice
                    </button>
                )}   
            </div>        
            <div ref={printRef} className="container pt-3 pb-3">



            {/* Header with logo and invoice info */}
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <img
                        src="/logo.png"
                        alt="Logo"
                        style={{ height: "100px" }}
                    />
                    <div style={{ textAlign: "right" }}>
                        <h4 className='text-info'>Invoice #{invoiceIni}-{invoiceData.orderID}</h4>
                        <p>Date: {showdatetimein(invoiceData.createdAt)}</p>
                    </div>
                    </div>

                    <hr style={{ margin: "20px 0" }} />

                    {/* Bill To */}
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ marginBottom: "20px" }}>
                        <h5 className='mb-2'>Bill To:</h5>
                        <b>{studentData.name}</b>
                        <p><i className='fa fa-envelope'></i> {studentData.email}</p>
                        <p><i className='fa fa-phone'></i> {studentData.mobile}</p>
                        {studentData.address && (
                            <p><i className='fa fa-map'></i> {studentData.address}</p>
                        )}
                        
                        

                        </div>
                        <div style={{ marginBottom: "20px" }}>
                        <h5 className='mb-2'>From:</h5>
                        <b>Acumen Global Training and Development</b>
                        <p>
                            <i className='fa fa-map'></i> Office no.14, 3rd floor
                            <br />Mohammed Bin Rashid Al Maktoum Charitable and Humanitarian Foundation,
                            <br />PO Box 82378 Al Mamzar,
                            <br />Dubai - UAE
                        </p>
                        </div>
                    </div>

                    {/* Items Table */}
                    <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginBottom: "20px",
                    }}
                    >
                    <thead>
                        <tr style={{ background: "#f2f2f2" }}>
                        <th style={thStyle}>Product</th>
                        <th style={thStyle}>Start Date</th>
                        <th style={thStyle}>End Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((item, index) => (
                        <tr key={index}>
                            <td style={tdStyle}>{
                                    coursesData[item.targetID] && (
                                        <>
                                            <img
                                                // src={coursesData[item.targetID].image}
                                                src={`${UPLOADNODEURLCDN}${coursesData[item.targetID].image}`}
                                                alt={coursesData[item.targetID].title}
                                                style={{ width: '100px', float: 'left', marginRight: '10px', marginBottom: '15px' }}
                                            />
                                            {coursesData[item.targetID].title}
                                            <br />
                                            <small>{coursesData[item.targetID].metaDescription}</small>
                                            <div styke={{ clear: 'both'}}></div>
                                        </>
                                    )
                            }</td>
                            <td style={tdStyle}>{item.validFromDate}</td>
                            <td style={tdStyle}>{item.validity === "876000" ? "Lifetime" : item.validToDate}</td>
                        </tr>
                        ))}
                    </tbody>
                    </table>

                    {/* Total */}
                    <div style={{ textAlign: "right", fontSize: "18px", fontWeight: "bold" }}>
                        Total: {invoiceData.paymentCurrency} {invoiceData.receivedAmount}
                    </div>

                    <p style={{ marginTop: "40px", fontSize: "14px", textAlign: "center" }}>
                        Thank you for your business!
                        <br />
                        By completing this purchase, you agree to our Terms & Conditions: <a href='//acumenglow.com/terms' target="_BLANK">acumenglow.com/terms</a>, For refund policy details, visit: <a href='//acumenglow.com/refund-policy' target="_BLANK">acumenglow.com/refund-policy</a>
                    </p>

                    <p style={{ marginTop: "40px", fontSize: "14px", textAlign: "center" }}>
                        This is a system-generated invoice. No signature is required.
                    </p>
            </div>
        </div>
        </>
    );
};


const thStyle = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "left",
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "8px",
};

export default Invoice;
